module.exports = __webpack_public_path__ + "static/folk-ph music-125ed31ee70b0b2feb5397581b3aede4.wav";